import { render, staticRenderFns } from "./variant-picker.vue?vue&type=template&id=63d01d82&"
import script from "./variant-picker.vue?vue&type=script&lang=js&"
export * from "./variant-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports